export enum HttpTypes {
  HTTP_CANCELED = 'HTTP_CANCELED'
}
